import { ACCESS_TOKEN_KEY } from '../constants/token'

export const authHeader = () => {
    let accessToken = JSON.parse(localStorage.getItem(ACCESS_TOKEN_KEY))
    if (accessToken) {
        return 'bearer ' + accessToken
    } else {
        return {}
    }
}